import { CREATE_APPOINTMENT_ACTION, CREATE_HEDGEFUND_AUDITLOGS, FOLLOW_ALLOCATOR, GET_ALLOCATORS_DETAIL, GET_ALLOCATOR_INFO, GET_ALLOCATOR_USERS, GET_ALLOCATOR_USER_LIST, GET_ALL_ADMIN_LIST, GET_HEDGEFUND_USERS, HEDGEFUND_CONNECTION } from "./constants";

export const getAllocatorDetail = (id) => {
  return {
    type: GET_ALLOCATORS_DETAIL,
    id,
  };
};

export function followAllocator(allocatorId, follow, onSuccess) {
  return {
    type: FOLLOW_ALLOCATOR,
    allocatorId,
    follow,
    onSuccess,
  };
}

export function CreateAuditLogs(payload) {
  return {
    type: CREATE_HEDGEFUND_AUDITLOGS,
    payload
  };
}

export const getAllocatorUsers = (id) => {
  return {
    type: GET_ALLOCATOR_USERS,
    id,
  };
};

export const getAdminUsers = () => {
  return {
    type: GET_ALL_ADMIN_LIST,
  };
};
export const getHedgeFundUsers = () => {
  return {
    type: GET_HEDGEFUND_USERS,
  };
};

export function createAppointment(payload, onSuccess) {
  return {
    type: CREATE_APPOINTMENT_ACTION,
    payload,
    onSuccess,
  };
}

export const showHedgeFundSchedule = (tenantId) => {
  return {
    type: HEDGEFUND_CONNECTION,
    tenantId
  };
};

export const getAllocatorInfoAction = (id) => {
  return {
    type: GET_ALLOCATOR_INFO,
    id,
  };
};

export const getAllocatorUserListAction = (id) => {
  return {
    type: GET_ALLOCATOR_USER_LIST,
    id,
  };
};